import { Component, OnInit, ViewChild } from "@angular/core";
import { Router, ActivatedRoute } from "@angular/router";
import { UserWalletService } from "src/app/services/userWallet.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { environment } from "src/environments/environment";
import {v4 as uuidv4} from 'uuid';
import { formatNumber } from "src/app/_helpers/must-match.validator";
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormControl,
} from "@angular/forms";
import { WindowRefService } from "src/app/services/window-ref.service";
import { WalletpaymentService } from "src/app/services/walletPayments.service";
import {
  ConfirmationService,
  MenuItem,
  ConfirmEventType,
  MessageService,
} from "primeng/api";
import { UserService } from "src/app/services/user.service";
// import { KycService } from "src/app/services/kyc.service";
import { v4, v6 } from 'public-ip';

@Component({
  selector: 'app-wallet-conversion',
  templateUrl: './wallet-conversion.component.html',
  styleUrls: ['./wallet-conversion.component.scss'],
  providers: [MessageService], 
})
export class WalletConversionComponent implements OnInit {
  availableClasses: string[] = ["body-dark", "bg-white", ""];
  currentClassIdx: number = 0;
  bodyClass: string;
  public walletlist: any = [];
  public userlist: any = [];
  public loading: boolean;
  public totalRecords = 0;
  errorMessage: string;
  public loggedInUser;
  paginationOption;
  downloadFlg: boolean;
  totalCoins;
  totalDeductedCoin;
  totalAvailableCoins;
  step: number = 0;
  activeIndex: number = 0;
  selectCashCoin: FormGroup;
  redemptionCash: any;
  redemptionCoin: any;
  totalCash;
  totalDeductedCash;
  addCashmodal: boolean = false;
  showThankyouModal: boolean = false;
  addCoinmodal: boolean = false;
  totalAvailableCash;
  public userId;
  selectcoinForm: FormGroup;
  convertAmountForm: FormGroup;
  submitted = false;
  username;
  noData: boolean;
  coinsubmitted = false;
  userdetails: any;
  kycList: any;
  kyclist: any;
  allKycList: any;

  coinCashData: any;
  cashCoinData: string = 'CONTESTCASH';
  actualCash: any;
  actualCoin: any;
  redemptionAmount: any;
  transferCash: any;
  deductionCas: any;
  tranferAmountCash: any;
  redempCoin: any;
  tdsData: any;
  commissionData: any;
  totalTdsCommissionDeduction: any;
  totalcreatedAmount: any;
  bankId: any;
  bankDetaiols: any;
  displayParameter: any;
  inPutCoin: any;
  totalCoinTdsCommission: any;
  totalCoinCreatedAmoun: any;
  coinTds: any;
  coinCommission: any;
  listOfBank: any;
  userBankid: any;
  showMessage: boolean = false;
  noKycAdded: boolean = false;
  noKycActive: boolean = false;
  userRole: any;
  kycBankDetails: any;
  publicIpAddr: any;
  selectedBankAccount: any;
  userName: any;
  userEmail: any;
  isSendRequestButttonDisable: boolean = false;
  idempotencyKey = uuidv4();
  totalContestCash: any;
  totalDeductedContestCash: any;
  totalAvailableMoney: number = 0;
  selectedMoneyTypeAmount: any;
  tdsDeduction: any = 0;
  userTotalAggregateAmount: any;
  userTotalWithdrawnAmount: any;
  netWinning: number = 0;
  isDialogVisible: boolean =false;
  gameTDsPercentage: number = environment.TDs*100;

  constructor(
    private tokenStorage: TokenStorageService,
    private route: ActivatedRoute,
    private userWalletService: UserWalletService,
    // private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private winRef: WindowRefService,
    private router: Router,
    private userService: UserService,
    private formBuilder: FormBuilder,
    // private kycService: KycService,

  ) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.userId = this.loggedInUser.userdata.id;
      this.userName = this.loggedInUser.userdata.fullName;
      this.userEmail = this.loggedInUser.userdata.email;
      this.userRole = this.loggedInUser.userdata.rolename
    }

    // this.convertAmountForm = this.formBuilder.group({
    //   amount: ["", [Validators.required, CustomValidators.number]],
    // });
    this.convertAmountForm = this.formBuilder.group({
      //amount: ["", [Validators.required, Validators.pattern(/^-?(0|[1-9]\d{3,})?$/)]],
      amount: ["", [Validators.required, Validators.min(1)]],
    });

    this.userdetails = this.getUserDetail();
    // this.kycList = this.loadUserKyc();
  }
  tdsInfro(event){
    event.preventDefault()
    this.router.navigate(["/tdsInfo"]);

  }


  selectedAmountType(amount) {
    this.selectedMoneyTypeAmount = amount;
  }

 
  get f2() {
    return this.convertAmountForm.controls;
  }

  getUserDetail() {
    var query = "?filterByDisable=false&filterByUserid=" + this.userId;
    this.userWalletService.getUserWalletList(query).subscribe(
      (data) => {
        this.loading = false;
        this.walletlist = data.data.items;
        this.totalCash = data.data.totalCash;
        this.totalDeductedCash = data.data.totalDeductedCash;
        this.totalAvailableCash = this.totalCash - this.totalDeductedCash;
        this.totalCoins = data.data.totalCoins;
        this.totalDeductedCoin = data.data.totalDeductedCoin;
        this.totalAvailableCoins = this.totalCoins - this.totalDeductedCoin;
        this.totalContestCash = data.data.totalContestCash;
        this.totalDeductedContestCash = data.data.totalDeductedContestCash;
        this.userTotalAggregateAmount = data.data.userTotalAggregateAmount;
        this.userTotalWithdrawnAmount = data.data.userTotalWithdrawnAmount;
        this.totalAvailableMoney = this.totalContestCash - this.totalDeductedContestCash;
        this.totalRecords = data.data.totalCount;
        this.selectedMoneyTypeAmount = this.totalAvailableCash;
      },
      (err) => {
        this.errorMessage = err.error.message;
      }
    );
  }
  onCancel(){
    this.isDialogVisible = false;
  }

  next() {
    this.step = this.step + 1;
  }
  back() {
    this.step = this.step - 1;
  }
  backHome() {
    if (this.userRole == "academy") {
      this.router.navigate(["/refer-earn"]);
    } else {
      this.router.navigate(["/my-wallet"]);

    }
  }



  onSubmit(): void {
    if (this.convertAmountForm.invalid) {
      return;
    }
    const redemptionAmount = this.convertAmountForm.value.amount;
    this.redemptionAmount = this.convertAmountForm.value.amount;
    // if (this.userRole == 'player' || this.userRole == 'proplayer' || this.userRole == 'coach'  || this.userRole == 'user') {
    //   //this.tdsData = this.redemptionAmount * environment.TDs;
    //   this.tdsData = 0;
    //   this.totalTdsCommissionDeduction = Math.round(this.tdsData);
    //   //this.totalcreatedAmount = this.redemptionAmount - this.totalTdsCommissionDeduction;
    //   this.totalcreatedAmount = this.redemptionAmount;
    // }
    if(this.cashCoinData === 'CONTESTCASH') {
      console.log('netWinning:',(Number(this.redemptionAmount) + this.userTotalWithdrawnAmount) - this.userTotalAggregateAmount);
      this.netWinning = (Number(this.redemptionAmount) + this.userTotalWithdrawnAmount) - this.userTotalAggregateAmount
      this.tdsDeduction = this.netWinning > 0 ? Math.round(this.netWinning * environment.TDs):0;
      this.totalcreatedAmount =Number(this.redemptionAmount) - this.tdsDeduction;
    }else{

      this.totalcreatedAmount = this.redemptionAmount;
    }


    if (this.userRole == 'academy') {
      this.totalcreatedAmount = this.redemptionAmount;
    }
    // this.commissionData = this.redemptionAmount * 0.10;
    this.inPutCoin = this.redemptionAmount / 10;
    this.coinTds = this.inPutCoin / 100;
    this.coinCommission = this.inPutCoin / 1000;
    this.totalCoinTdsCommission = this.coinTds + this.coinCommission;
    this.totalCoinCreatedAmoun = this.inPutCoin - this.totalCoinTdsCommission;
 if (this.cashCoinData == "CONTESTCASH") {
      if (
        redemptionAmount > this.totalAvailableMoney 
      ) {
        return;
      } else {
        this.submitted = true;
        this.step = 1;
      }
    } 
  }
  showDialog(){
    if(this.totalcreatedAmount<0){
      alert("Your Convert Amount is in negative,Try to increase convert amount");
      return
    }
    this.isDialogVisible = true;
  }
  async onConfirm() {
    this.isSendRequestButttonDisable = true;
    if (this.cashCoinData === "CONTESTCASH") {
      let ConvertCash: any = {
        userId: this.userId,
        wallettype: this.cashCoinData,
        tds: this.tdsDeduction,//this.tdsData,
        commission: this.commissionData,
        tdsDeductedAmount:  this.tdsDeduction?this.totalcreatedAmount:null,
        tdsPercentage: this.tdsDeduction?environment.TDs*100:null,
        amount: this.redemptionAmount,
        action: "SUBTRACT",
        description: '',
        status: true,
        convertMoney: true,
      };
      console.log('cashCoinData:',ConvertCash);
      this.userWalletService.addUserWallet(ConvertCash).subscribe((res) => {
        this.showMessage = true;
       
        this.messageService.add({
          key: "toastmsg",
          severity: "success",
          summary: "Successful",
          detail: 'Contest Cash Converted to TPL Cash Successfully',
          life: 2000,
        });
        this.submitted = true;
        setTimeout(() => {
          // let currentUrl = this.router.url;
          if (this.userRole == "academy") {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(["/refer-earn"]);
          } else {
            this.router.routeReuseStrategy.shouldReuseRoute = () => false;
            this.router.onSameUrlNavigation = 'reload';
            this.router.navigate(["/my-wallet"]);

          }
          // this.router.onSameUrlNavigation = "reload";
          // this.router.navigate([currentUrl]);
        }, 2000);
      },
        err => {
          this.isSendRequestButttonDisable = false;
          this.messageService.add({ key: "toastmsg", severity: "error", summary: "Error", detail: err.error.error, life: 6000 });
          return;
        });
      // this.step = 4;
    }else{
      alert("Wallet Type should be Contest Cash");
    }
  }
  getDisplayValueCash() {
    this.redemptionAmount = this.convertAmountForm.value.amount;
  }

  getDisplayValueMoney() {
    this.redemptionAmount = this.convertAmountForm.value.amount;
  }

  getDisplayValueCoin() {
    this.redemptionAmount = this.convertAmountForm.value.amount;
    this.inPutCoin = this.redemptionAmount / 10;
  }




}
